import type { SVGProps } from "react";

/**
 * chevron-large-right, chev right, next
 * @category Arrows
 */
export default function IconChevronLargeRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M9.75 2.75L14.6422 10.9778C15.0168 11.6078 15.0168 12.3922 14.6422 13.0221L9.75 21.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
